import { OnboardingWaitlistContainer } from "../components/OnboardingWaitlist/OnboardingWaitlistContainer";

export function OnboardingWaitlistPage() {
  return <OnboardingWaitlistContainer />;
}

export default OnboardingWaitlistPage;
